export default {
    getAllFirstFlowList: state => {
        return state.allFirstFlowList;
    },
    getLogoBrand: state => {
        return state.logoBrand;
    },
    getSymbolList: state => {
        return state.symbolList;
    },
    getSymbolStringList: state => {
        return state.symbolStringList;
    },
    getSymbolNumberList: state => {
        return state.symbolNumberList;
    },
    getVariableList: state => {
        return state.variableList;
    },
    getVariableStringList: state => {
        return state.variableStringList;
    },
    getVariableNumberList: state => {
        return state.variableNumberList;
    },
    getReplyTypeList: state => {
        return state.replyTypeList;
    },
    getIntentTypeList: state => {
        return state.intentTypeList;
    },
    getApiConfigList: state => {
        return state.apiConfigList;
    },
    getTierMasterdataList: state => {
        return state.tierMasterdataList;
    },
    getLanguageActiveId: state => {
        return state.languageActiveId;
    },
}